import { Component, ChangeDetectionStrategy , inject} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Almacen } from '@/app/models/Almacen';
import { AlmacenesService } from '@/app/services/almacenes.service';
import { CrearAlmacenComponent } from '@/app/components/catalogos/Almacenes/crear-almacen/crear-almacen.component';
import { EditarAlmacenComponent } from '@/app/components/catalogos/Almacenes/editar-almacen/editar-almacen.component';

@Component({
    selector: 'app-lista-almacen',
    templateUrl: './lista-almacenes.component.html',
    styleUrls: ['./lista-almacenes.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ListaAlmacenesComponent {
  private spinner = inject(NgxSpinnerService);

   //Lista
   lista: Almacen[] = [];
   
   constructor(
    private almacenesService: AlmacenesService,
    private toastr: ToastrService, 
    private router: Router,
    private dialog: MatDialog,

  ){
    this.getAlmacenes();
  }

  getAlmacenes(){
    this.spinner.show();

    this.almacenesService.getAlmacenes().subscribe({
      next: (data: any)=>{
        this.lista = data.Almacenes;
        this.spinner.hide();
      },
      error: (err) =>{
        this.spinner.hide();
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  abrirModalCrearAlmacen(){
    const dialogRef = this.dialog.open(CrearAlmacenComponent, {
      width: '580px',
      height: '630px',
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) this.getAlmacenes();
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }


  abrirModalEditarAlmacen(modelo: Almacen){
    const dialogRef = this.dialog.open(EditarAlmacenComponent, {
      width: '580px',
      height: '630px',
      panelClass: 'custom-dialog-container',
      data: modelo,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) this.getAlmacenes();
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }

}
